import { getSandboxFunc } from "../../../tools/getSandboxFunction";
export function getMethodArgSchema(code) {
  try {
    // eslint-disable-next-line no-eval
    // const fn = eval(code);
    const fn = getSandboxFunc(code.trim());
    const names = getParameterName(fn);
    return names.map(name => ({
      id: name
    }));
  } catch (error) {
    console.error(error);
    return [];
  }
}
function getParameterName(fn) {
  if (typeof fn !== 'function') return [];
  const COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/gm;
  const DEFAULT_PARAMS = /=[^,)]+/gm;
  const FAT_ARROWS = /=>.*$/gm;
  let code = fn.toString();
  code = code.replace(COMMENTS, '').replace(FAT_ARROWS, '').replace(DEFAULT_PARAMS, '');
  const result = code.slice(code.indexOf('(') + 1, code.indexOf(')')).match(/([^\s,]+)/g);
  return result === null ? [] : result;
}
//# sourceMappingURL=getMethodArgsSchemas.js.map
